import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import noop from 'lodash/noop'

const useStyles = makeStyles(() => ({
  inputWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    border: 'var(--border-neutral-thin)',
    borderRadius: 'var(--border-radius-sm)',
    backgroundColor: 'var(--tc-input-base)',
    display: 'flex',
    transition: 'outline 200ms ease-in-out',
    outline: '1px solid transparent',
    '&:focus-within': {
      outline: '1px solid var(--color-primary-500)'
    },
    '& input': {
      border: 'none',
      outline: 'none',
      padding: 'var(--padding-md)',
      backgroundColor: 'transparent',
      width: '100%',
      fontSize: 'var(--text-size-sm)',
      color: 'var(--color-neutral-900)',
      fontFamily: 'var(--font-sans)',
      '&:disabled': {
        cursor: 'not-allowed',
        opacity: 0.6
      },
      '&::-webkit-calendar-picker-indicator': {
        cursor: 'pointer'
      }
    }
  }
}))

const SydDateInput = forwardRef(function SydDateInput ({
  name,
  value,
  onChange = noop,
  onBlur = noop,
  disabled = false,
  className
}, ref) {
  const classes = useStyles()

  return (
    <div className={clsx(classes.inputWrapper, className)}>
      <input
        type='date'
        name={name}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        ref={ref}
      />
    </div>
  )
})

SydDateInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

export default SydDateInput
